<template>
    <div class="widget p-3 m-1" v-if="goal && goal.domain">
        <div class="d-flex justify-content-between align-content-center">
            <p class="font-weight-bold " :style="`color: ${goal.domain.color}`">
                Domain: Skill Aquisition - Tact:
            </p>
        </div>
        <p v-if="edit && userIsGoalOwner"><input v-model="editedGoalTitle" type="text" /></p>
        <p v-else="" class="mb-0" style="font-size: 1.5rem">{{ goal.title }}</p>
        <small class="font-weight-bold text-muted">Method of Tracking: Cold Probe</small><br />
        <span class="d-flex align-items-center small text-muted mb-0">
            <em class="mr-2"
                >goal created: {{ moment(goal.created_at).format("MMMM DD, YYYY") }}
                {{ goal.created_by_user ? `by ${goal.created_by_user.name}` : "" }}</em
            >
            <profile-picture
                v-if="goal.created_by_user"
                :name="goal.created_by_user.name"
                :size="'sm'"
                :url="goal.created_by_user.profile_photo_url"
            ></profile-picture
            ><span>
                <i
                    class="fa text-primary ml-2"
                    v-tooltip="goal.is_shared ? 'This is a shared goal' : null"
                    :class="goal.is_shared ? 'fa-users' : 'fa-fw'"
                ></i>
            </span>
        </span>
        <hr style="width:100%;margin:0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;" />
        <textarea
            v-if="edit && userIsGoalOwner"
            class="form-control"
            v-model="editedGoalDescription"
        />
        <p v-else="">{{ goal.description }}</p>
        <hr style="width:100%;margin:0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;" />
        <div class="mb-0">
            <b>Number of mastered targets - goal: </b>
            <input
                v-if="edit && userIsGoalOwner"
                style="max-width: 2.5rem"
                v-model.number="parameters.goal"
                type="text"
            />
            <span v-else="">{{ parameters.goal }}</span
            >.<br />
            <b>1. Baseline</b> introduced track
            <input
                v-if="edit && userIsGoalOwner"
                style="max-width: 2.5rem"
                v-model="parameters.baseline_num_times_repeat_question"
                type="text"
            />
            <span v-else="">{{ parameters.baseline_num_times_repeat_question }}</span> times in a
            row.
            <input
                v-if="edit && userIsGoalOwner"
                style="max-width: 2.5rem"
                v-model="parameters.baseline_considered_mastered"
                type="text"
            />
            <span v-else="">{{ parameters.baseline_considered_mastered }}</span> successes
            considered mastered.
        </div>
        <div class="mb-0">
            <b>2. Teaching</b> aquired completed
            <input
                v-if="edit && userIsGoalOwner"
                style="max-width: 2.5rem"
                v-model="parameters.teaching_num_times_repeat_question"
                type="text"
            />
            <span v-else="">{{ parameters.teaching_num_times_repeat_question }}</span> successes
            <span v-if="edit && userIsGoalOwner" class="">
                <input
                    class=""
                    v-model="parameters.teaching_is_consecutive_days_required"
                    type="checkbox"
                    value=""
                    id="consecutive"
                />
                <label class="" for="consecutive">
                    consecutive days
                </label>
            </span>
            <span v-else="">
                <span v-if="parameters.teaching_is_consecutive_days_required">
                    consecutive days
                </span>
            </span>
            .
        </div>
        <div class="mb-0">
            <b>3. Retention</b> wait
            <input
                v-if="edit && userIsGoalOwner"
                style="max-width: 2.5rem"
                v-model="parameters.retention_num_days_reprobe"
                type="text"
            />
            <span v-else="">{{ parameters.retention_num_days_reprobe }}</span> days to probe to
            achieve mastery.
        </div>
        <hr style="width:100%;margin:0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;" />
        <span v-if="edit && userIsGoalOwner" class="">
            <input
                class=""
                v-model="parameters.therapist_can_add_targets"
                type="checkbox"
                value=""
                id="addtargets"
            />
            <label class="" for="addtargets">
                therapist can add targets
            </label>
        </span>
        <span v-else="">
            <span v-if="parameters.therapist_can_add_targets">
                therapist can add targets
            </span>
        </span>
        <span v-if="edit && userIsGoalOwner">
            <input
                class=""
                v-model="parameters.therapist_can_track_probes"
                type="checkbox"
                value=""
                id="trackprobes"
            />
            <label class="" for="trackprobes">
                therapist can track probes
            </label>
        </span>
        <span v-else="" class="ml-2">
            <span v-if="parameters.therapist_can_track_probes">
                therapist can track probes
            </span>
        </span>
        <hr style="width:100%;margin:0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;" />
        <div class="position-relative">
            <p class="mb-0">Targets:</p>
            <div class="mb-1" v-if="edit">
                <small class="text-muted">Add target: </small
                ><input
                    type="text"
                    v-model="newTarget"
                    @keyup.enter="addTarget()"
                    name="target"
                    class="custom-input mx-2"
                    :class="{ 'border-danger': itemAlreadyExists }"
                />
                <a
                    class="btn btn-sm btn-outline-primary"
                    v-tooltip="'Add parameter'"
                    @click="addTarget()"
                    ><i class="text-primary fa fa-plus"></i
                ></a>
            </div>
            <span class="small font-italic text-danger">{{
                itemAlreadyExists ? "This item is already present in the list." : " "
            }}</span>
            <div>
                <small class="badge-light p-1 m-1 rounded" v-for="t in parameters.targets"
                    >{{ t.name
                    }}<i
                        v-if="edit"
                        class="fa fa-times-circle cursor-pointer ml-1"
                        @click="removeTarget(t)"
                    ></i>
                </small>
            </div>

            <div class="w-100 d-flex justify-content-end mt-3">
                <template v-if="edit">
                    <button
                        class="btn btn-sm btn-link font-weight-bold text-muted m-1"
                        @click="edit = false"
                    >
                        Cancel
                    </button>
                    <button
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase m-1"
                        @click="updateGoal"
                    >
                        <i v-if="saving" class="fa fa-spin fa-circle-o-notch mr-1"></i
                        >{{ saving ? "Saving..." : "Update goal" }}
                    </button>
                </template>
                <template v-else="">
                    <button
                        class="text-uppercase font-weight-bold btn btn-sm btn-primary"
                        :disabled="!userIsGoalOwner && !canAddParameters"
                        @click="userIsGoalOwner || canAddParameters ? editDescription() : null"
                    >
                        <i class="fa fa-fw fa-edit mr-2"></i>Edit
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ProfilePicture from "../ui/ProfilePicture";

export default {
    name: "GoalsDescriptionProbe",
    props: ["goal"],
    components: { ProfilePicture },
    data() {
        return {
            edit: false,
            saving: false,
            newTarget: null,
            parameters: {},
            editedGoalTitle: "",
            editedGoalDescription: "",
            teachNumRepeatQuest: "",
        };
    },
    watch: {
        goal: {
            handler: function() {
                this.initialize();
            },
            immediate: true,
        },
    },
    computed: {
        itemAlreadyExists() {
            return this.parameters.targets.find(target => target.name === this.newTarget);
        },
        userIsGoalOwner() {
            return _.get(this.goal, "created_by_user.id", "id") === this.$root.user.id;
        },
        canAddParameters() {
            return _.get(this.goal, "parameters.therapist_can_add_targets", false);
        },
    },
    methods: {
        initialize() {
            this.parameters = JSON.parse(JSON.stringify(this.goal.parameters));
            this.editedGoalTitle = this.goal.title;
            this.editedGoalDescription = this.goal.description;
        },
        editDescription() {
            this.edit = true;
            this.teachNumRepeatQuest = this.goal.parameters.teaching_num_times_repeat_question;
        },
        addTarget() {
            if (!this.itemAlreadyExists) {
                this.parameters.targets.push({
                    name: this.newTarget,
                    introduced: null,
                    acquired: null,
                    retained: null,
                    updated: this.moment().format("YYYY-MM-DD"),
                    stage: "baseline",
                    baseline: [],
                    teaching: [],
                    mastered: false,
                    next_probe: null,
                    progress: 0,
                });
                this.newTarget = null;
            }
        },
        removeTarget(target) {
            const index = this.parameters.targets.indexOf(target);
            this.parameters.targets.splice(index, 1);
        },
        updateGoal() {
            this.saving = true;
            axios
                .patch(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}`, {
                    title: this.editedGoalTitle,
                    description: this.editedGoalDescription,
                    parameters: this.parameters,
                })
                .then(response => {
                    this.$emit("goal-updated");
                    this.saving = false;
                    this.edit = false;
                })
                .catch(error => {
                    console.error(error);
                    this.saving = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
.custom-input {
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
    padding: 0.25rem 0.5rem;
    font-size: 0.7875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
</style>
